import { Component, OnInit , ViewEncapsulation} from '@angular/core';
import { ConfigService } from 'app/admin/shared/services/config/config.service';

@Component({
    selector: '.footer_wrapper',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {


    ngOnInit() {

    }

}
